import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
} from '@mui/material';
import {
  People,
  Phone,
  TrendingUp,
  Assignment,
} from '@mui/icons-material';

const StatsCards = ({ stats = {} }) => {
  const cards = [
    {
      title: 'Today\'s Leads',
      value: stats.today_leads || 0,
      icon: <People />,
      color: '#1976d2',
    },
    {
      title: 'Today\'s Calls',
      value: stats.today_calls || 0,
      icon: <Phone />,
      color: '#2e7d32',
    },
    {
      title: 'This Week',
      value: stats.week_leads || 0,
      icon: <TrendingUp />,
      color: '#ed6c02',
    },
    {
      title: 'This Month',
      value: stats.month_leads || 0,
      icon: <Assignment />,
      color: '#9c27b0',
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Avatar sx={{ bgcolor: card.color, mr: 2 }}>
                  {card.icon}
                </Avatar>
                <Box>
                  <Typography variant="h4" component="div" fontWeight="bold">
                    {card.value}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {card.title}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;